import type { DrawSelectorState } from '../../../DrawSelectorItem/DrawSelectorItem';
import type { DrawSelectorItemType } from '../../DrawSelector';

/**
 * Get the state of a draw selector item.
 *
 * States:
 * - default
 * - selected
 * - completed
 * - disabled
 *
 * @param isCompleted - Whether the draw is completed.
 * @param isSelected - Whether the draw is selected.
 * @param isDisabled - Whether the draw is disabled.
 * @returns The state of the draw selector item.
 */
const getState = ({ isSelected, isDisabled }: Pick<DrawSelectorItemType, 'isSelected' | 'isDisabled'>): DrawSelectorState => {
  if (isDisabled) return 'disabled';
  if (isSelected) return 'selected';
  return 'default';
};

export { getState };
